import {
  LOCATION_DETAILS, LOCATION_STATE
} from '../constants/AppConstants';

const initialState = {
  zip: '',
  lat: '',
  lon: '',
  locationEnabled: '',
  usingCurrentLocation: false
};

export default (state = initialState, action) => {

  switch (action.type) {
    case LOCATION_DETAILS: {
      return {
        ...state,
        zip: action.zip,
        lat: action.lat,
        lon: action.lon,
        usingCurrentLocation: action.usingCurrentLocation
      }
    }
      break;
    case LOCATION_STATE: {
      return {
        ...state,
        zip: '',
        lat: action.lat,
        lon: action.lon,
        locationEnabled: action.enabled
      }
    }
      break;
    default: {
      return state;
    }
  }
};
